import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { homeTranslations } from '../data/translations/homeTranslations';
import heroImage from '../assets/hero2.jpg';

export default function Home() {
  const { language } = useLanguage();
  const t = homeTranslations[language].home;

  return (
    <div className="pt-20 bg-background text-on-surface font-body selection:bg-secondary-container selection:text-on-secondary-container">
      <section className="px-8 pt-16 pb-8 lg:pt-24 lg:pb-10 max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-12">
        <div className="lg:w-1/2">
          <h1 className="anim-fade-up anim-delay-1 font-headline text-4xl lg:text-6xl font-extrabold text-primary leading-tight tracking-tight mb-8">
            {t.title.split('[[').map((part, i) => {
              if (part.includes(']]')) {
                const [highlighted, rest] = part.split(']]');
                return (
                  <React.Fragment key={i}>
                    <span className="text-secondary">{highlighted}</span>
                    {rest}
                  </React.Fragment>
                );
              }
              return part;
            })}
          </h1>

          <p className="anim-fade-up anim-delay-2 opacity-70 text-lg leading-relaxed max-w-xl mb-10 text-balance">
            {t.description}
          </p>

          <div className="anim-fade-up anim-delay-3 flex flex-wrap gap-4">
            <button
              className="bg-primary text-on-primary px-8 py-4 rounded-lg font-headline font-bold text-base shadow-lg hover:shadow-secondary/20 transition-all flex items-center gap-3"
              onClick={() => { document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' }); }}
            >
              {language === 'en' ? "Start Implementation" : "Iniciar Implementación"}
              <span className="material-symbols-outlined text-sm">analytics</span>
            </button>
            <button
              className="px-8 py-4 rounded-lg font-headline font-bold text-base border border-border bg-surface hover:border-secondary transition-all flex items-center gap-2"
              onClick={() => { document.getElementById('servicios')?.scrollIntoView({ behavior: 'smooth' }); }}
            >
              {language === 'en' ? "View Ecosystem" : "Ver Ecosistema"}
              <span className="material-symbols-outlined">arrow_forward</span>
            </button>
          </div>
        </div>

        <div className="anim-fade-in anim-delay-4 lg:w-1/2 relative">
          <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
            <img
              src={heroImage}
              alt="AI-assisted radiology diagnosis at Intelimed"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>
    </div>
  );
}
